import { useSearchParams } from 'react-router-dom'

/**
 * Resolves module landing view from URL query params.
 * Default: transactions (transaction cards grid).
 * ?view=overview — overview dashboard
 * ?tab=reports — reports (footer Reports section)
 * ?tab=masters — masters (footer Masters section)
 */
export function useModuleView() {
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab')
  const view = searchParams.get('view')

  if (tab === 'reports') return 'reports'
  if (tab === 'masters') return 'masters'
  if (view === 'overview' || tab === 'overview') return 'overview'
  return 'transactions'
}
